// extracted by mini-css-extract-plugin
module.exports = {"dialog":"styles_dialog__zGP3r","container":"styles_container__Bh-d_","buttonsContainer":"styles_buttonsContainer__3bDbc"};